var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroSectionCircle3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.6708,
    cy: 27.6571,
    r: 27.5,
    transform: "rotate(-22.2757 27.6708 27.6571)",
    fill: "url(#paint0_linear_329_214)",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_329_214",
    x1: 50.4294,
    y1: 10.0192,
    x2: 6.42939,
    y2: 49.0881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#298BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15476A",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroSectionCircle3);
export default __webpack_public_path__ + "static/media/heroSectionCircle3.ce7d806c5de139a965dbe53ef1a55d62.svg";
export { ForwardRef as ReactComponent };